import React from "react";

export default function ReviewIcon() {
  return (
    <svg width={17} height={16} fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#a)">
        <path
          fill="#F4B400"
          d="M5.854 5.119 8.038.792A.516.516 0 0 1 8.5.5c.183 0 .366.097.465.292l2.184 4.327 4.898.696a.537.537 0 0 1 .453.505.548.548 0 0 1-.17.445l-3.523 3.356.83 4.73c.078.443-.36.79-.746.592L8.5 13.187l-4.389 2.256a.52.52 0 0 1-.146.05c-.342.06-.668-.254-.6-.642l.83-4.73L.673 6.765a.55.55 0 0 1-.172-.403.58.58 0 0 1 .085-.302.513.513 0 0 1 .37-.245l4.898-.696ZM8.5 12.027a.5.5 0 0 1 .232.056l3.686 1.894-.694-3.957a.564.564 0 0 1 .162-.505l2.907-2.77-4.052-.576a.525.525 0 0 1-.393-.288L8.501 2.223l-.001.003v9.801Z"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M.5 0h16v16H.5z" />
        </clipPath>
      </defs>
    </svg>
  );
}
